// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Servicos_BuscarCategoriasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/servicos/buscar_categorias
 *
 * Returns all service categories ordered by name (same shape as
 * /config/servicos_categorias/carrega_categorias). Reuses
 * ServicosCategorias_CategoriaRow because both endpoints select the
 * same contracted columns from `config_servicos_categorias`.
 */
import type { ServicosCategorias_CategoriaRow } from './ServicosCategorias_CategoriaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Servicos_BuscarCategoriasResponseDados = ServicosCategorias_CategoriaRow[];

export type Servicos_BuscarCategoriasResponse = ApiResponse<Servicos_BuscarCategoriasResponseDados>;

registerResponseContract('Servicos_BuscarCategoriasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      servicoscategoria_id:                  { type: 'number',  required: true },
      servicoscategoria_nome:                { type: 'string',  required: true },
      servicoscategoria_prazo_retorno_dias:  { type: 'number',  required: true },
      servicoscategoria_prazo_garantia_dias: { type: 'number',  required: true },
      servicoscategoria_produtos_associados: { type: 'number',  required: true },
    },
  },
})
